import { WorkflowAction } from './WorkflowAction';

// One discovered item's fate at disposition: whether it became a retrieval run.
// `invalid` marks an item the sweep captured without a usable pointer.
export interface DispositionItem {
  referenceOrUrl?: string | null;
  patientName?: string | null;
  disposition: 'created' | 'skipped' | 'invalid';
  workflowId?: string | null;
}

export interface DiscoveryDisposition {
  created: number;
  skipped: number;
  superseded: number;
  spawnedWorkflowIds: string[];
  items: DispositionItem[];
}

// The DisposePortalActivity action kind (OLIO-2756): turns each discovered item into its
// own portal_automation retrieval run and completes with a `discovery_disposition`
// summary. The sweep card reads it to show only the items that became work.
export class DisposePortalActivityAction extends WorkflowAction {
  // Null until disposition has run (or on a pre-verdict summary shape), so the card can
  // fall back to rendering the raw discovered list.
  get disposition(): DiscoveryDisposition | null {
    const value = this.outputFor('discovery_disposition') as Partial<DiscoveryDisposition> | undefined;
    if (!value || typeof value !== 'object' || !Array.isArray(value.items)) return null;
    return {
      created: value.created ?? 0,
      skipped: value.skipped ?? 0,
      superseded: value.superseded ?? 0,
      spawnedWorkflowIds: Array.isArray(value.spawnedWorkflowIds) ? value.spawnedWorkflowIds : [],
      items: value.items,
    };
  }
}
